import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa"; // Import the left arrow icon
import sampleVideo from "../videos/nutriscale.mp4"; // Import the local video file

function NutriScale() {
  const navigate = useNavigate();

  // Function to handle the left arrow click and scroll to the "Work" section
  const handleBackToWork = () => {
    navigate("/"); // Navigate to the root route
    setTimeout(() => {
      const workSection = document.getElementById("work");
      if (workSection) {
        // Scroll to the "Work" section after the page has loaded
        workSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // Small delay to allow the navigation to complete
  };

  return (
    <div className="min-h-screen bg-[#0a192f]">
      <div className="flex flex-col justify-start items-start h-full">
        {/* Using button to call the navigation handler */}
        <button
          onClick={handleBackToWork}
          className="text-white border-2 hover:bg-pink-600 hover:border-pink-600 px-4 py-3 my-4 ml-6 mt-7"
        >
          <FaArrowLeft className="text-white text-2xl" />
        </button>
        <h1 className="text-4xl sm:text-5xl ml-24 font-bold text-[#ccd6f6] mt-10 lg:ml-36">
          Nutriscale
        </h1>

        <div className="container mx-auto mt-16">
          <video
            className="w-full md:w-3/4 lg:w-1/2 h-auto md:h-104 mx-auto" // Adjust height here
            controls // Add controls for play/pause etc.
          >
            <source src={sampleVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="container mx-auto mt-10 px-6 md:px-44">
          <h2 className="text-3xl sm:text-5xl font-bold text-[#8892b0]">
            Description :
          </h2>
          <p
            className="mt-6 text-[#8892b0] pb-16 "
            style={{ fontSize: "1.25rem" }}
          >
            {" "}
            {/* Adjust the font size */}
            Built an Indian food dataset with Label Studio and trained CNN and
            YOLOv11 models to automatically detect food items and predict their
            caloric and nutrient values.
          </p>
        </div>
      </div>
    </div>
  );
}

export default NutriScale;
